<template>
  <div>
    <PageAllow controller="StockMaterialHistories" :action="'view'" />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color py-4 mx-4">
        <v-expansion-panels v-model="panels" multiple accordion>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-card-title class="ms-n4 py-0">
                {{ $t("CRUD.info", [$t("StockMaterialHistories.objName")]) }}
                <v-spacer />
                <v-sheet
                  class="pt-1 transparent-background-color d-inline-block"
                >
                  <!-- 导出 -->
                  <v-btn
                    v-if="
                      $permission.permissionAllow(
                        'StockMaterialHistories',
                        'export'
                      )
                    "
                    small
                    color="print"
                    dark
                    class="ms-1"
                    @click.stop="exportExcel()"
                  >
                    {{ $t("StockMaterialHistories.DetailFields.export") }}
                  </v-btn>
                </v-sheet>
              </v-card-title>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider />
              <v-row no-gutters class="mt-4 table-style">
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockMaterialHistories.Fields.stockName")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_material_history
                        ? stock_material_history.stock_name
                        : ""
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockMaterialHistories.Fields.created_time")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_material_history
                        ? stock_material_history.created
                        : "" | formatTime
                    }}
                  </v-card>
                </v-col>
                <v-col cols="12" md="4">
                  <v-card class="pa-2 text-no-wrap" outlined tile>
                    <span class="secondary--text">
                      {{ $t("StockMaterialHistories.Fields.created_name")
                      }}{{ $t("Global.colon") }}
                    </span>
                    {{
                      stock_material_history
                        ? stock_material_history.created_name
                        : ""
                    }}
                  </v-card>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <div class="px-4 pb-4" v-resize="$mainResizer">
        <v-card class="px-4">
          <v-toolbar flat class="transparent-background-color">
            <v-row no-gutters align="center">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockMaterialHistories.objName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <span class="pr-6">
                <span class="font-weight-bold me-2"
                  >{{ $t("StockMaterialHistories.DetailFields.count_total")
                  }}{{ $t("Global.colon") }}</span
                >
                <span class="red--text">
                  {{ stock_material_history.count_total | formatTwoDot }}
                </span>
              </span>
              <span>
                <span class="font-weight-bold me-2"
                  >{{ $t("StockMaterialHistories.DetailFields.price_total")
                  }}{{ $t("Global.colon") }}</span
                >
                {{ $t("Global.money") }}
                <span class="red--text">
                  {{ stock_material_history.price_total | formatMoney }}
                </span>
              </span>
            </v-row>
          </v-toolbar>
          <v-divider />
          <v-data-table
            :headers="detailsHeaders"
            :items="historyDetailItems"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            :no-data-text="
              $t('StockMaterialHistories.DetailFields.DetailNoData')
            "
            class="pb-2"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                class="transparent-background-color"
                align-self="center"
              >
                <v-row no-gutters class="me-n3 mt-2">
                  <v-row no-gutters>
                    <v-spacer />
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="filter"
                        clearable
                        :label="$t('Search.filter')"
                        :hint="
                          $t(
                            'StockMaterialHistories.DetailFields.keywordSearchHint'
                          )
                        "
                        v-on:keyup.enter="options.keyword = filter.trim()"
                      />
                    </v-col>
                  </v-row>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}{{ item.total_price | formatMoney }}
            </template>
            <template v-slot:item.current_count="{ item }">
              {{ $numberFormatter.formatTwoDot(item.current_count, true) }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import stockMaterialHistories from "@/api/stock_material_histories";

const defaultOptions = {
  keyword: "",
};
export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },

  computed: {
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.currentStocks"),
          disabled: false,
          href: "/current-stocks",
        },
        {
          text: i18n.t("StockMaterialHistories.objName"),
          disabled: false,
          href: "/current-stocks/detail/stock-material-history",
        },
        {
          text: i18n.t("StockMaterialHistories.DetailFields.detail"),
          disabled: true,
          href: ";",
        },
      ];
      return items;
    },
    detailsHeaders() {
      var headers = [
        {
          text: i18n.t("StockMaterialHistories.DetailFields.category_name"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockMaterialHistories.DetailFields.material_name"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("StockMaterialHistories.DetailFields.unit"),
          align: "start",
          value: "unit",
        },
        {
          text: i18n.t("StockMaterialHistories.DetailFields.current_count"),
          align: "start",
          value: "current_count",
        },
        {
          text: i18n.t("StockMaterialHistories.DetailFields.total_price"),
          align: "start",
          value: "total_price",
        },
      ];

      return headers;
    },
    historyDetailItems() {
      return this.stock_material_history_details.map((detail) => {
        detail.Description = i18n.t(
          this.settings
            ? this.settings.material_name_display_type == 4
              ? "Material.nameWithCodeAndStandard"
              : this.settings.material_name_display_type == 3
              ? "Material.materialNameWithCodeAndStandard"
              : this.settings.material_name_display_type == 2
              ? "Material.materialNameWithCode"
              : "Material.materialName"
            : "Material.materialName",
          [detail.material_code, detail.material_name, detail.standard_name]
        );
        return detail;
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  mounted() {
    this.getHistoryFromAPI();
  },

  data: () => ({
    panels: [0],
    filter: "",
    stock_material_history_details: [],
    count_total: null,
    price_total: null,
    stock_material_history: {},
    options: JSON.parse(JSON.stringify(defaultOptions)),
    paging: {},
  }),

  methods: {
    getHistoryFromAPI() {
      stockMaterialHistories
        .fetchOne(
          Object.assign({}, this.options, { id: this.$route.params.id })
        )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stock_material_history = response.data;
              this.stock_material_history_details =
                response.data.stock_material_history_details;
              this.paging = response.data.paging;
            }
          }.bind(this)
        );
    },
    exportExcel() {
      stockMaterialHistories.exports(
        Object.assign({}, this.options, { id: this.$route.params.id })
      );
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getHistoryFromAPI();
      },
    },
  },
};
</script>
